const state = {
}

const getters = {

}

const mutations = {

}

const actions = {
  batchCreate ({ rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-taobao-trade/batch-create', params)
  },
  attachTrackingNo ({ rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-taobao-trade/attach-tracking-no', params)
  },
  index ({ rootState }, params) {
    return rootState.axios.get('/jyb/v1frontend/tp-taobao-trade/index', { params })
  },
  attachTrackingNoItem ({ rootState }, params) {
    return rootState.axios.post('/jyb/v1frontend/tp-taobao-trade/attach-tracking-no-item', params)
  },
  attachTrackingNoItemId ({ rootState }, params) {
    params = params.params ? params : { params }
    return rootState.axios.post('/jyb/v1frontend/tp-taobao-trade/attach-tracking-no-itemid', params.params, params.options)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
